import React from "react";
import { connect } from "react-redux";
import { Field } from "formik";

import Select from "../../../DataEntry/Select";
import { MICROSOFT_AZURE } from "../../utils";

class Index extends React.Component<any, any> {
  state = {
    showPrinter: false,
    showReader: false,
  };

  handleChangePrinter = ({ target }: any) => {
    localStorage.setItem("crm_printer", target.value);
  };

  handleChangeReader = ({ target }: any) => {
    localStorage.setItem("crm_reader", target.value);
  };

  handleChangeDoor = ({ target }: any) => {
    localStorage.setItem("crm_door", target.value);
  };

  handlePreview = () => {
    const { formik, onPreview } = this.props;
    onPreview(formik);
  };

  handleReprint = () => {
    const { formik, onReprint } = this.props;
    onReprint(formik);
  };

  handleToggleLoading = () => {
    const { formik, onToggleLoading } = this.props;
    onToggleLoading(formik);
  };

  handleUndo = () => {
    const { formik, onUndo } = this.props;
    onUndo(formik);
  };

  renderTagsQuantity = () => {
    const { assets } = this.props;

    return (
      assets.reduce(
        (total: number, { tags }: any) => total + tags?.length || 0,
        0,
      ) || 0
    );
  };

  render() {
    const { showPrinter, showReader } = this.state;
    const {
      doors,
      formik,
      assets,
      loading,
      printers,
      readers,
      crm_return,
      viewOnly,
    } = this.props;
    const { values } = formik;
    const reader = readers.find(({ id }: any) => id == values.reader);
    const door =
      reader?.category === MICROSOFT_AZURE
        ? doors.find(({ id }: any) => id == values.door)
        : {};

    return (
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-3">
          <h1 className="txt-color-blueDark">
            <img
              src="/images/purchase-order-receiving.png"
              height="32"
              width="32"
            />
            Quick Return
          </h1>
        </div>
        <div className="col-md-4">
          <div className="text-center">
            <span
              style={{ fontSize: "90px", lineHeight: "60px" }}
              className="count bold"
            >
              {this.renderTagsQuantity()}
            </span>
            <br />
            <span>Tag(s) Read</span>
          </div>
        </div>
        <div className="col-md-3" style={{ paddingTop: "10px" }}>
          <span className="sn-gray-green-circle"></span>
          <span
            style={{
              verticalAlign: "super",
              marginLeft: "5px",
            }}
            {...(viewOnly ? {} : { className: "pointer" })}
            onClick={() =>
              this.setState({ showReader: !viewOnly && !showReader })
            }
          >
            Reader:&nbsp;
            {reader &&
              [reader.name, door?.name].filter((t: string) => !!t).join(" - ")}
            <i className="fa fa-cog" style={{ paddingLeft: "10px" }}></i>
          </span>
          <br />
          <div style={showReader ? {} : { display: "none" }}>
            <div className="checkbox">
              <Field
                name="reader"
                className="form-control pointer"
                component={Select}
                disabled={viewOnly || loading}
                list={[["", "Select RFID Reader"]].concat(
                  readers.map(({ id, name }: any) => [id, name]),
                )}
                style={
                  reader?.category === MICROSOFT_AZURE ? { width: "49%" } : {}
                }
                onChange={this.handleChangeReader}
              />

              {reader?.category === MICROSOFT_AZURE && (
                <Field
                  name="door"
                  className="form-control pointer"
                  component={Select}
                  disabled={viewOnly || loading}
                  list={[["", ""]].concat(
                    doors.map(({ id, name }: any) => [id, name]),
                  )}
                  style={{ marginLeft: "2%", width: "49%" }}
                  onChange={this.handleChangeDoor}
                />
              )}
            </div>
          </div>
          <span className="sn-gray-green-circle"></span>
          <span
            style={{
              verticalAlign: "super",
              margin: "10px 0 0 5px",
              display: "inline-block",
            }}
            className="pointer"
            onClick={() => this.setState({ showPrinter: !showPrinter })}
          >
            Printer:&nbsp;
            {printers.find(({ id }: any) => id == values.printer)?.name}
            <i className="fa fa-cog" style={{ paddingLeft: "10px" }} />
          </span>
          <br />
          <div style={showPrinter ? {} : { display: "none" }}>
            <div className="checkbox">
              <Field
                name="printer"
                className="form-control pointer"
                component={Select}
                list={[["", "Select RFID Printer"]].concat(
                  printers.map(({ id, name }: any) => [id, name]),
                )}
                onChange={this.handleChangePrinter}
              />
            </div>
          </div>
        </div>
        <div className="col-md-2 text-right">
          {!!crm_return?.id
            ? [
                <button
                  key="preview"
                  className="sn-btn sn-btn-md sn-btn-green"
                  type="button"
                  onClick={this.handlePreview}
                >
                  Preview Receipt
                </button>,
                <button
                  key="reprint"
                  type="button"
                  className="sn-btn sn-btn-md sn-btn-blue"
                  onClick={this.handleReprint}
                >
                  Re-Print Receipt
                </button>,
              ]
            : [
                <button
                  key="loading"
                  className={`sn-btn sn-btn-md sn-btn-${loading ? "red" : "green"}`}
                  disabled={viewOnly}
                  type="button"
                  onClick={this.handleToggleLoading}
                >
                  {loading ? "Stop" : "Start"}
                </button>,
                <button
                  key="submit"
                  type="submit"
                  className="sn-btn sn-btn-md sn-btn-blue"
                  disabled={viewOnly || formik.submitting || !assets.length}
                >
                  Submit &amp; Print Receipt
                </button>,
              ]}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  doors: state.doors.data,
  assets: state.assets.data,
  printers: state.printers.data,
  readers: state.readers.data,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
